import { Pipe, PipeTransform } from '@angular/core'

export interface OrganizationStatuses {
    suspendedAt?: string | Date | null
    activatedAt?: string | Date | null
}

@Pipe({
    name: 'organizationStatus',
    standalone: true,
})
export class OrganizationStatusPipe implements PipeTransform {
    transform(entity: OrganizationStatuses): string {
        if (entity.suspendedAt) {
            return 'Suspended'
        }
        if (entity.activatedAt) {
            return 'Active'
        }
        return 'Pending'
    }
}
